import { useCallback, useMemo, useState } from 'react';
import { useIsPreview } from './useIsPreview';
export const useConfirmModal = ({
  onConfirm,
  onReject
}) => {
  const isPreview = useIsPreview();
  const [isOpen, setIsOpen] = useState(false);
  const openConfirmModal = useCallback(() => {
    setIsOpen(true);
  }, []);
  const handleReject = useCallback(() => {
    setIsOpen(false);
    onReject === null || onReject === void 0 || onReject();
  }, [onReject]);
  const handleConfirm = useCallback(() => {
    setIsOpen(false);
    onConfirm();
  }, [onConfirm]);
  const confirmModalProps = useMemo(() => {
    // In HubSpot's theme preview the app runs inside a sandboxed iframe
    // without allow-forms. ConfirmDialog's confirm button is type="submit"
    // and fires onConfirm via the form's onSubmit handler, which the browser
    // blocks in that context. In preview mode we override the button to
    // type="button" with a direct onClick so the handler fires regardless.
    if (isPreview) {
      return {
        confirmButtonProps: {
          type: 'button',
          onClick: evt => {
            evt.stopPropagation();
            handleConfirm();
          }
        },
        onReject: handleReject
      };
    }
    return {
      onConfirm: handleConfirm,
      onReject: handleReject
    };
  }, [isPreview, handleConfirm, handleReject]);
  return {
    isOpen,
    openConfirmModal,
    confirmModalProps
  };
};